// Defines main application routes

import { routes } from "./routes";
import React from "react";
import { Suspense } from "react";
//Pages
import SamplePage from "../pages/pages/SamplePage";
import Error404 from "../components/pages/others/errorPage/Error404";
import UsersPage from "../pages/UsersPage";
import UserRegisterPage from "../pages/pages/UserRegisterPage";
import UserUpdatePage from "../pages/UserUpdatePage";
import UpdatePasswordPage from "../pages/UpdatePasswordPage";
import DistributaryZoneListPage from "../pages/DistributaryZoneListPage";
import DistributaryZoneFormPage from "../pages/DistributaryZoneForm";
import UpdateDistrbutoryZonepage from "../pages/UpdateDistrbutoryZonepage";
import SchemeVillagePage from "../pages/SchemeVillagePage";
import UpdateSchemeVillagePage from "../pages/UpdateSchemeVillagepage";
import AddSchemeVillagePage from "../pages/AddSchemeVillagePage";

import ChackPage from "../pages/ChackPage";
import UpdateChackPage from "../pages/UpdateChackPage";
import ChackInstrumentPage from "../pages/ChackInstrumentPage";
import UpdateChackInstrumentPage from "../pages/UpdateChackInstrumentPage";
import AddChackPage from "../pages/pages/AddChackPage";
import AddChackInstrumentDetailPage from "../pages/AddChackInstrument";
import EmailPage from "../pages/EmailPage";
import UpdateEmailPage from "../pages/UpdateEmail";
import AddEmailPage from "../pages/AddEmailPage";
import ChackValveDetailPage from "../pages/ChackValveDetailPage";
import UpdateChackValveDetailPage from "../pages/UpdateChackValveDetailPage";
import AddChackValveDetailPage from "../pages/AddChackValveDetailPage"; 
import KhasaraPage from "../pages/KhasaraPage";
import UpdateKhasarPage from "../pages/UpdateKhasar";
import AddKhasarPage from "../pages/AddKhasar";
import UserProfilePage from "../pages/UserProfilePage";
import FarmerPage from "../pages/FarmerPage";
import KmlPage from "../pages/KmlPage";
import UpdateKmlPage from "../pages/UpdateKmlPage";
import AddKmlPage from "../pages/AddKmlPage";

import MapViewPage from "../pages/MapViewPage";
import MapView from "../components/mapView/MapView";
import KmLLayer from "../components/mapView/KmlLayer";
import ChackComponent from "../components/mapView/ChackComponent";
import ProjectSettingsPage from "../pages/ProjectSettingsPage";
import UpdateProjectPage from "../pages/UpdateProjectPage";
import AddProjectPage from "../pages/AddProjectPage";
import OmsListPage from "../pages/OmsListPage";
import UpdateOmsPage from "../pages/UpdateOmsPage";
import AddOmsPage from "../pages/AddOmsPage";
import Dashboard from "../pages/DashboardPage";
import CheckEmail from "../auth/ForgotPassword";
import EmailSenderPage from "../pages/EmailSenderPage";

import Report from "../components/reports/Report";

import AlarmsTablePage from "../pages/AlarmsTablePage";
import UpdateFarmerPage from "../pages/UpdateFarmerPage";
import AddFarmerPage from "../pages/pages/AddFarmerPages";
import BeneficiaryList from "../components/configuration/beneficiarylist/BeneficiaryList";
import AddBeneficiary from "../components/configuration/beneficiarylist/AddBeneficiary";
import UpdateBeneficiary from "../components/configuration/beneficiarylist/UpdateBeneficiary";
import PumpingStation from "../components/PumpingStation/PumpingStation";
import AddPumpingStation from "../components/PumpingStation/AddPumpingStation";
import UpdatePumpingStation from "../components/PumpingStation/UpdatePumpingStation";
import AddPumpinghStationPage from "../pages/AddPumpingStationPage";
import UpdatePumpingStationPage from "../pages/UpdatePumpingStationPage";
import UpdatePumpingStationHistory from "../components/PumpingStation/UpdatePumpingStationHistory";
import AddPumpingStationHistoryPage from "../pages/AddPumpingStationHistoryPage";
import TrendsPage from "../pages/TrendsPage";
import GetReportPumpingStationPage from "../pages/GetReportPumpingStationPage";
import PowerConsumptionAddPage from "../pages/PowerConsumptionAddPage";
import PowerConsumptionPage from "../pages/PowerConsumptionPage";
import PowerConsumptionUpdate from "../components/PowerConsumption/PowerConsumptionUpdate";
import UpdatePowerConsumptionPage from "../pages/UpdatePowerConsumptionPage";
import SchemeSummaryReport from "../components/schemeSummary/SchemeSummaryReport";
import SchemeWiseSummaryPage from "../pages/SchemeWiseSummaryPage";
import AddSchemeSummary from "../components/schemeSummary/AddSchemSummary";
import WaterCharges from "../components/configuration/WaterCharges/WaterCharges";
import UpdateWaterCharges from "../components/configuration/WaterCharges/UpdateWaterCharges";
import WaterChargesAdd from "../components/configuration/WaterCharges/WaterChargesAdd";
import path from "path";
import PumpingStationControl from "../components/PumpingStation/PumpingStationControl";
import SLD from "../components/PumpingStation/SLD";
import MapViewSecond from "../components/mapView/MapViewSecond";
import AllWuaReport from "../components/WuaReport/AllWuaReport";
import WuaWiseSummary from "../components/WuaReport/WuaWiseSummary";
import DMSList from "../components/configuration/DMSList/DMSList";
import AddWua from "../components/configuration/Wua/AddWua";
import WuaList from "../components/configuration/Wua/WuaList";
import UpdateWua from "../components/configuration/Wua/UpdateWua";
import WuaWaterDistribution from "../components/configuration/WuaDistribution/WuaWaterDistribution";
import { elementClosest } from "@fullcalendar/core/internal";
import AddChakInGroup from "../components/ShivnalaSchedule/AddChakInGroup";
import GroupScheduler from "../components/ShivnalaSchedule/GroupScheduler";
import GroupAdd from "../components/configuration/GroupName/GroupAdd";
import GroupNameList from "../components/configuration/GroupName/GroupNameList";
import GroupUpdate from "../components/configuration/GroupName/GroupUpdate";
import ViewEditChakFromGroup from "../components/ShivnalaSchedule/ViewEditChakFromGroup";
import ScheduleStatus from "../components/ShivnalaSchedule/ScheduleStatus";
import LoadingComponent from "../components/lodingComponent";
import PumpingStatusReport from "../components/PumpingStation/PumpingStatusReport";
import WuaDashboard from "../components/dashboard/WuaDashboard";
import PumpingStationKwhReport from "../components/PumpingStation/PumpingStationKwhReport";
import PumpingStationRunHours from "../components/PumpingStation/PumpingStationRunHours";
import CombineReport from "../components/PumpingStation/CombineReport";
import HeadQuarterWaterReport from "../components/WuaReport/HeadQuarterWaterReport";
import PumpRunReport from "../components/PumpingStation/PumpRunReport";
const MapViewLazy = React.lazy(()=> import('../pages/MapViewPage'))


export const AppRoutes = [
  
  //Pages
  { path: routes.Sample, element: <SamplePage /> },
  { path: routes.Users, element: <UsersPage /> },
  { path: routes.UserRegister, element: <UserRegisterPage /> },
  { path: routes.UpdateUser, element: <UserUpdatePage /> },
  { path: routes.UpdatePassword, element: <UpdatePasswordPage /> },
   {path: routes.UserProfilePage, element: <UserProfilePage/> },
  { path: routes.DistributaryZoneForm, element: <DistributaryZoneFormPage /> },
  { path: routes.DistributaryZoneList, element: <DistributaryZoneListPage /> },
  { path: routes.DistributaryZoneUpdate, element: <UpdateDistrbutoryZonepage /> },
  
  { path: routes.SchemeVillageList, element: <SchemeVillagePage /> },
  { path: routes.SchemeVillageUpdate, element: <UpdateSchemeVillagePage /> },
  { path: routes.SchemeVillageAdd, element: <AddSchemeVillagePage /> },
  { path: routes.ChackList, element: <ChackPage /> },
  { path: routes.ChackUpdate, element: <UpdateChackPage /> },
  { path: routes.ChackInstrument, element: <ChackInstrumentPage /> },
  { path: routes.ChackInstrumentUpdate, element: <UpdateChackInstrumentPage /> },
  { path: routes.ChackAdd, element: <AddChackPage /> },
  { path: routes.AddChackInstrument, element: <AddChackInstrumentDetailPage /> },
  { path: routes.EmailList, element: <EmailPage /> },
  { path: routes.EmailUpdate, element: <UpdateEmailPage /> },
  { path: routes.AddEmail, element: <AddEmailPage /> },
  { path: routes.ChackValveDetail, element: <ChackValveDetailPage /> },
  { path: routes.UpdateChackValveDetail, element: <UpdateChackValveDetailPage /> },
  { path: routes.AddChackValveDetail, element: <AddChackValveDetailPage /> },
  { path: routes.KhasaraList, element: <KhasaraPage /> },
  { path: routes.KhasaraUpdate, element: <UpdateKhasarPage /> },
  { path: routes.AddKhasara, element: <AddKhasarPage /> },
  {path:routes.FarmerList, element: <FarmerPage/>},
  {path:routes.FarmerUpdateL, element:<UpdateFarmerPage/>},
  {path:routes.AddFarmer, element:<AddFarmerPage/>},
  {path:routes.KmlList,element:<KmlPage/>},
  {path:routes.AddKml, element:<AddKmlPage/>},
  {path:routes.UpdateKml, element:<UpdateKmlPage/>},
  {path : routes.MapView, element: (
    <Suspense fallback={<LoadingComponent/>}>
      <MapViewLazy />
    </Suspense>
  )},
  //project
  {path:routes.ProjectList,element:<ProjectSettingsPage/>},
  {path:routes.ProjectUpdate,element:<UpdateProjectPage/>},
  {path:routes.ProjectAdd,element:<AddProjectPage/>},
  {path:routes.OmsList,element:<OmsListPage/>},
  {path:routes.OmsUpdate,element:<UpdateOmsPage/>},
  {path:routes.OmsAdd,element:<AddOmsPage/>},
  {path:routes.DashBoard,element:<Dashboard/>},
  {path:routes.EmailSender,element:<EmailSenderPage/>},
  //mqtt
  
 // {path:routes.PopUp,element:<ChackComponent/>}
   // report 
   {path:routes.report,element:<Report/>},

   //
  
   {path:routes.Alarms,element:<AlarmsTablePage/>},
   {path:routes.BeneficiaryList,element:<BeneficiaryList/>},
   {path:routes.BeneficiaryAdd,element:<AddBeneficiary/>},
   {path:routes.BeneficiaryUpdate,element:<UpdateBeneficiary/>},

    {path:routes.PumpingStationList,element :<PumpingStation/>},
    {path:routes.PumpingStaionAdd,element:<AddPumpinghStationPage/>},
    {path:routes.PumpingStationUpdate,element:<UpdatePumpingStationPage/>},

    {path:routes.UpdatePumpingStationHistory,element:<UpdatePumpingStationHistory/>},
    {path:routes.AddPumpingStationHistory,element:<AddPumpingStationHistoryPage/>},
    {path:routes.Trends, element:<TrendsPage/>},
    {path:routes.GetReportPumpingStation,element:<GetReportPumpingStationPage/>},
    {path:routes.PowerConsuumption, element:<PowerConsumptionPage/>},
    {path:routes.AddPowerConsumption, element:<PowerConsumptionAddPage/>},
    {path:routes.UpdatePowerConsumption,element:<UpdatePowerConsumptionPage/>},
    {path:routes.SchemeSummaryReport,element:<SchemeSummaryReport/>},
    {path:routes.SchemeWiseSummary,element:<SchemeWiseSummaryPage/>},
    {path:routes.AddSchemeSummary,element:<AddSchemeSummary/>},
    {path:routes.WaterCharges,element:<WaterCharges/>},
    {path:routes.UpdateWaterCharges,element:<UpdateWaterCharges/>},
    {path:routes.AddWaterCharges,element:<WaterChargesAdd/>},
    {path:routes.PumpingStationControl,element:<PumpingStationControl/>},
    {path:routes.SLD,element:<SLD/>},
    {path:routes.MapViewSecond,element:<MapViewSecond/>},
    {path:routes.WuaAllReport,element:<AllWuaReport/>},
    {path:routes.WuaWiseReport,element:<WuaWiseSummary/>},
    {path:routes.DmsList,element:<DMSList/>},
    {path:routes.AddWua,element:<AddWua/>},
    {path:routes.WuaList,element:<WuaList/>},
    {path:routes.WuaUpdate,element:<UpdateWua/>},
    {path:routes.WuaWaterDistribution,element:<WuaWaterDistribution/>},
    {path:routes.DeviceInGroup,element:<AddChakInGroup/>},
    {path:routes.GroupScheduler,element:<GroupScheduler/>},
    {path:routes.GroupList,element:<GroupNameList/> },
    {path:routes.GroupAdd,element:<GroupAdd/>},
    {path:routes.GroupUpdate,element:<GroupUpdate/>},
    {path:routes.ViewAddChakInGroup,element:<ViewEditChakFromGroup/>},
    {path:routes.ScheduleStatus,element:<ScheduleStatus/>},
    {path:routes.PumpingStatusReport,element:<PumpingStatusReport/>},
    {path:routes.WuaDashboard,element:<WuaDashboard/>},
    {path:routes.PumpKwh,element:<PumpingStationKwhReport/>},
    {path:routes.PumpRunhours,element:<PumpingStationRunHours/>},
    {path:routes.CombineReport,element:<CombineReport/>},
    {path:routes.WuaMonth,element:<HeadQuarterWaterReport/>},
    {path:routes.PumpRun,element:<PumpRunReport/>}
];

export const AuthRoutes = [

  // Error Pages
  { path: routes.ErrorPages.Error404, element: <Error404 /> },
  
];
